import React from 'react';

export const SlideGroupContext = React.createContext();
